import React, { useMemo } from 'react';

import { IMPORT_STEPS } from '../../constants/import.constants';
import FooterButtons from '../FooterButtons';

const ImportFooter = ({
  isLoading,
  startNewImport,
  downloadImportResult,
  handleImportClick,
  hasImportError,
  importStep,
  handleCancel,
  importStatuses,
}) => {
  const selectedRows = useMemo(() => importStatuses?.filter((s) => s.Checked), [importStatuses]);

  const buttons = useMemo(() => {
    if (hasImportError) {
      return [
        { label: 'Cancel', onClick: handleCancel, disabled: isLoading },
        { label: 'Start New Import', variant: 'primary', onClick: startNewImport },
      ];
    } else {
      switch (importStep) {
        case IMPORT_STEPS.INITIAL_STEP:
          return [
            { label: 'Cancel', onClick: handleCancel, disabled: isLoading },
            { label: 'Import', variant: 'primary', disabled: true },
          ];
        case IMPORT_STEPS.UPLOAD_FILE:
          return [
            { label: 'Cancel', onClick: handleCancel, disabled: isLoading },
            {
              label: 'Import',
              variant: 'primary',
              onClick: handleImportClick,
              disabled: !selectedRows?.length || isLoading,
            },
          ];
        case IMPORT_STEPS.UPLOAD_COMPLETED:
          return [
            { label: 'Cancel', onClick: handleCancel },
            {
              label: 'Download Form Import Document',
              variant: 'primary',
              onClick: downloadImportResult,
            },
            { label: 'Start New Import', variant: 'primary', onClick: startNewImport },
          ];
        default:
          return [{ label: 'Cancel', onClick: handleCancel }];
      }
    }
  }, [
    hasImportError,
    handleCancel,
    isLoading,
    startNewImport,
    importStep,
    handleImportClick,
    selectedRows?.length,
    downloadImportResult,
  ]);

  return <FooterButtons buttons={buttons} />;
};

export default ImportFooter;
